<form
  #editAvailabilityForm="ngForm"
  (keydown.enter)="$event.preventDefault()"
  data-cy="employment-edit-availability-dialog">
  <div mat-dialog-title>
    <h1 mat-dialog-title>{{ data.personName }}</h1>
  </div>
  <div mat-dialog-content>
    <h2>{{ ("type" | i18n) || "Typ" | titlecase }}</h2>
    <mat-button-toggle-group
      [(ngModel)]="data.status"
      (ngModelChange)="toggleAvailability()"
      name="availabilityToggle">
      <mat-button-toggle
        class="available-toggle"
        data-cy="availability-edit-available-toggle"
        [value]="employmentAvailabilityStatusEnum.AVAILABLE"
        >{{ ("available" | i18n) || "Verfügbar" }}</mat-button-toggle
      >
      <mat-button-toggle
        class="unavailable-toggle"
        data-cy="availability-edit-unavailable-toggle"
        [value]="employmentAvailabilityStatusEnum.UNAVAILABLE"
        >{{ ("unavailable" | i18n) || "Abwesend" }}</mat-button-toggle
      >
    </mat-button-toggle-group>
    <div class="row">
      <h2 mat-dialog-title>
        {{ ("timespan" | i18n) || "Zeitraum" | titlecase }}
      </h2>
      <div class="col-md-6">
        <mat-form-field>
          <mat-label>{{
            ("dateFrom" | i18n) || "Datum von" | titlecase
          }}</mat-label>
          <input
            matInput
            [value]="(data.startDate | date) || ''"
            readonly
            (click)="datePickerFrom.open()"
            required
            data-cy="datepicker-from" />
          <input
            matInput
            required
            name="datepickerFrom"
            (dateChange)="selectStartDate($event)"
            (click)="datePickerFrom.open()"
            (keydown)="$event.preventDefault()"
            [matDatepicker]="datePickerFrom"
            [(ngModel)]="data.startDate"
            hidden />
          <mat-datepicker-toggle
            matSuffix
            [for]="datePickerFrom"></mat-datepicker-toggle>
          <mat-datepicker #datePickerFrom></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <mat-label>{{
            ("dateTo" | i18n) || "Datum bis" | titlecase
          }}</mat-label>
          <input
            matInput
            [value]="(data.endDate | date) || ''"
            readonly
            (click)="datePickerTo.open()"
            required
            data-cy="datepicker-to" />
          <input
            matInput
            required
            name="datepickerTo"
            (dateChange)="selectEndDate($event)"
            (click)="datePickerTo.open()"
            (keydown)="$event.preventDefault()"
            [matDatepicker]="datePickerTo"
            [(ngModel)]="data.endDate"
            [min]="data.startDate"
            hidden />
          <mat-datepicker-toggle
            matSuffix
            [for]="datePickerTo"></mat-datepicker-toggle>
          <mat-datepicker #datePickerTo></mat-datepicker>
        </mat-form-field>
      </div>
      <div
        class="col-md-12"
        *ngIf="data.status === employmentAvailabilityStatusEnum.AVAILABLE">
        <mat-form-field>
          <mat-label>{{
            ("workloadInPercent" | i18n) || "Pensum in %" | titlecase
          }}</mat-label>
          <input
            matInput
            required
            type="number"
            min="1"
            max="100"
            name="workloadInput"
            [(ngModel)]="data.workload"
            data-cy="availability-edit-workload-input" />
        </mat-form-field>
      </div>
      <div
        class="col-md-12"
        *ngIf="data.status === employmentAvailabilityStatusEnum.UNAVAILABLE">
        <mat-form-field>
          <mat-label>{{
            ("unavailabilityReason" | i18n) || "Abwesenheit Grund"
          }}</mat-label>
          <mat-select
            [(ngModel)]="data.unavailableReason"
            required
            name="unavailableReasonSelect"
            data-cy="availability-edit-unavailable-reason-select">
            <mat-option
              [value]="unavailableReasonEnum.HOLIDAY"
              [attr.data-cy]="
                'availability-edit-unavailable-reason-' +
                unavailableReasonEnum.HOLIDAY
              "
              >{{
                ("unavailabilityReasonEnum." + unavailableReasonEnum.HOLIDAY
                  | i18n) || "Ferien"
              }}</mat-option
            >
            <mat-option
              [value]="unavailableReasonEnum.SICK"
              [attr.data-cy]="
                'availability-edit-unavailable-reason-' +
                unavailableReasonEnum.SICK
              "
              >{{
                ("unavailabilityReasonEnum." + unavailableReasonEnum.SICK
                  | i18n) || "Krankheit"
              }}</mat-option
            >
            <mat-option
              [value]="unavailableReasonEnum.TRAINING"
              [attr.data-cy]="
                'availability-edit-unavailable-reason-' +
                unavailableReasonEnum.TRAINING
              "
              >{{
                ("unavailabilityReasonEnum." + unavailableReasonEnum.TRAINING
                  | i18n) || "Weiterbildung"
              }}</mat-option
            >
            <mat-option
              [value]="unavailableReasonEnum.OTHER"
              [attr.data-cy]="
                'availability-edit-unavailable-reason-' +
                unavailableReasonEnum.OTHER
              "
              >{{
                ("unavailabilityReasonEnum." + unavailableReasonEnum.OTHER
                  | i18n) || "Andere"
              }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field>
          <mat-label>{{
            ("notes" | i18n) || "Bemerkungen" | titlecase
          }}</mat-label>
          <input
            matInput
            type="text"
            name="notesInput"
            [placeholder]="
              ('notesPlaceholder' | i18n) ||
              'Spezielles z.B. Frei am Wochenende, oder Frei an spezifischem Datum'
            "
            [(ngModel)]="data.notes"
            data-cy="availability-edit-notes-input" />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      *ngIf="data.availabilityId"
      mat-button
      class="delete-button"
      [mat-dialog-close]="{ id: data.availabilityId, toDelete: true }"
      data-cy="availability-edit-delete-button">
      <mat-icon svgIcon="delete-trash-remove"></mat-icon>
      <span class="mat-fab__label">
        {{ ("delete" | i18n) || "löschen" | uppercase }}</span
      >
    </button>
    <button
      mat-button
      class="cancel-button"
      (click)="onNoClick()">
      {{ ("cancel" | i18n) || "cancel" | uppercase }}
    </button>
    <button
      mat-button
      class="save-button"
      [disabled]="
        !data.startDate ||
        !data.endDate ||
        data.status === undefined ||
        (data.status === employmentAvailabilityStatusEnum.UNAVAILABLE &&
          !data.unavailableReason) ||
        (data.status === employmentAvailabilityStatusEnum.AVAILABLE &&
          !data.workload)
      "
      [mat-dialog-close]="{
        id: data.availabilityId,
        status: data.status,
        startDate: data.startDate,
        endDate: data.endDate,
        notes: data.notes,
        unavailableReason: data.unavailableReason,
        workload: data.workload
      }"
      data-cy="availability-edit-submit-button">
      <mat-icon svgIcon="save"></mat-icon>
      <span class="mat-fab__label">{{
        ("save" | i18n) || "speichern" | uppercase
      }}</span>
    </button>
  </div>
</form>
